.lead-react-container {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 96px;
}
